export enum ExternalSourceProviderEnum {
	ORA = 'ORA',
	STANDALONE = 'STANDALONE'
}
